import { render, staticRenderFns } from "./container-main-mobile.vue?vue&type=template&id=595d137e&lang=pug&"
import script from "./container-main-mobile.vue?vue&type=script&lang=js&"
export * from "./container-main-mobile.vue?vue&type=script&lang=js&"
import style0 from "./container-main-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports